export default {
    'galaxy-shadow': '0 0.1rem 0 0 #D9E2EC',
    'modal-shadow': '0 1.5rem 3.5rem 0 var(--color-box-shadow)',
    'action-bar-shadow': '0 0.2rem 0.6rem var(--color-box-shadow)'
};
